class VideoPlayer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists && !this.els['youtube-video']?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
    this.els?.close?.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.handleClose()
      }
    })
  }

  handleTrigger () {
    this.els.modal.element.showModal()

    if (this.dataset.videoType === 'shopify') {
      for (const source in this.els.video.element.children) {
        const videoSource = this.els.video.element.children[source]

        if (
          typeof videoSource.tagName === 'string' &&
          videoSource.tagName === 'SOURCE'
        ) {
          videoSource.src = videoSource.dataset.src
        }
      }

      this.els.video.element.load()
      this.els.video.element.play()
    }

    document.body.classList.toggle('util-SiteOverflowed', true)
  }

  handleClose () {
    if (this.dataset.videoType === 'shopify') {
      this.els?.video?.element.pause()
    }

    this.els?.modal?.element.close()

    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer)
}
